export const translations = {
  // ===== NAVBAR =====
  nav: {
    services: { sk: 'Služby', en: 'Services', de: 'Dienstleistungen' },
    forCompanies: { sk: 'Pre firmy', en: 'For Companies', de: 'Für Unternehmen' },
    forCandidates: { sk: 'Pre uchádzačov', en: 'For Candidates', de: 'Für Bewerber' },
    aboutUs: { sk: 'O nás', en: 'About Us', de: 'Über uns' },
    contact: { sk: 'Kontakt', en: 'Contact', de: 'Kontakt' },
    // Dropdown items
    temporaryEmployment: { sk: 'Dočasné zamestnanie', en: 'Temporary Employment', de: 'Zeitarbeit' },
    staffLeasing: { sk: 'Personálny leasing', en: 'Staff Leasing', de: 'Personalleasing' },
    recruitment: { sk: 'Recruitment', en: 'Recruitment', de: 'Rekrutierung' },
    outsourcing: { sk: 'Outsourcing', en: 'Outsourcing', de: 'Outsourcing' },
    hrConsulting: { sk: 'HR poradenstvo', en: 'HR Consulting', de: 'HR-Beratung' },
    manufacturing: { sk: 'Výrobné podniky', en: 'Manufacturing', de: 'Produktion' },
    logistics: { sk: 'Logistika', en: 'Logistics', de: 'Logistik' },
    itSector: { sk: 'IT sektor', en: 'IT Sector', de: 'IT-Sektor' },
    retail: { sk: 'Retail', en: 'Retail', de: 'Einzelhandel' },
  },

  // ===== HERO =====
  hero: {
    badge: { sk: 'Novinky', en: 'News', de: 'Neuigkeiten' },
    badgeText: { sk: 'Rozširujeme pôsobnosť na Slovensku', en: 'Expanding our presence in Slovakia', de: 'Wir erweitern unsere Präsenz in der Slowakei' },
    readMore: { sk: 'Čítať viac', en: 'Read more', de: 'Mehr lesen' },
    headline: { sk: 'Nájdeme vám tých správnych ľudí', en: 'We find the right people for you', de: 'Wir finden die richtigen Leute für Sie' },
    description: { 
      sk: 'Sme moderná agentúra dočasného zamestnávania, ktorá prepája talentovaných pracovníkov s firmami, ktoré ich potrebujú. Rýchlo, spoľahlivo a flexibilne.',
      en: 'We are a modern temporary employment agency that connects talented workers with companies that need them. Fast, reliable, and flexible.',
      de: 'Wir sind eine moderne Zeitarbeitsagentur, die talentierte Arbeitnehmer mit Unternehmen verbindet, die sie brauchen. Schnell, zuverlässig und flexibel.'
    },
    cta: { sk: 'Kontaktujte nás', en: 'Contact Us', de: 'Kontaktieren Sie uns' },
  },

  // ===== AI REALITY / SEARCH SECTION =====
  search: {
    headline1: { sk: 'Hľadáte pracovníkov?', en: 'Looking for workers?', de: 'Suchen Sie Arbeitskräfte?' },
    headline2: { sk: 'Máme ich.', en: 'We have them.', de: 'Wir haben sie.' },
    searchPlaceholder: { sk: 'Hľadám:', en: 'Searching:', de: 'Suche:' },
    // Stats
    stat1Value: { sk: '500+', en: '500+', de: '500+' },
    stat1Label: { sk: 'Obsadených pozícií', en: 'Positions Filled', de: 'Besetzte Stellen' },
    stat2Value: { sk: '100+', en: '100+', de: '100+' },
    stat2Label: { sk: 'Spokojných klientov', en: 'Satisfied Clients', de: 'Zufriedene Kunden' },
    stat3Value: { sk: '48h', en: '48h', de: '48h' },
    stat3Label: { sk: 'Priemerný čas obsadenia', en: 'Average Fill Time', de: 'Durchschnittliche Besetzungszeit' },
    stat4Value: { sk: '98%', en: '98%', de: '98%' },
    stat4Label: { sk: 'Spokojnosť klientov', en: 'Client Satisfaction', de: 'Kundenzufriedenheit' },
  },

  // ===== POSITIONS (rotating in search bar) =====
  positions: {
    list: {
      sk: ['Muráři', 'Montážnici', 'Zvárači', 'Skladníci', 'Operátori CNC', 'Vodiči VZV', 'Elektrikári', 'Maliari', 'Zámočníci', 'Tesári'],
      en: ['Bricklayers', 'Assemblers', 'Welders', 'Warehouse Workers', 'CNC Operators', 'Forklift Drivers', 'Electricians', 'Painters', 'Locksmiths', 'Carpenters'],
      de: ['Maurer', 'Monteure', 'Schweißer', 'Lagerarbeiter', 'CNC-Bediener', 'Gabelstaplerfahrer', 'Elektriker', 'Maler', 'Schlosser', 'Zimmerer']
    }
  },

  // ===== WHY WORKPRO =====
  whyWorkPro: {
    title: { sk: 'Prečo WorkPro?', en: 'Why WorkPro?', de: 'Warum WorkPro?' },
    card1Title: { sk: 'Rýchle obsadenie pozícií', en: 'Fast Position Filling', de: 'Schnelle Stellenbesetzung' },
    card1Desc: { 
      sk: 'Pracovníkov vám dodáme do 48 hodín. Máme rozsiahlu databázu preverených kandidátov pripravených nastúpiť.',
      en: 'We deliver workers within 48 hours. We have an extensive database of verified candidates ready to start.',
      de: 'Wir liefern Arbeitskräfte innerhalb von 48 Stunden. Wir haben eine umfangreiche Datenbank verifizierter Kandidaten, die bereit sind zu beginnen.'
    },
    card2Title: { sk: 'Prevzatie administratívy', en: 'Administration Takeover', de: 'Verwaltung übernehmen' },
    card2Desc: { 
      sk: 'Mzdy, zmluvy, odvody, BOZP - všetko riešime za vás. Sústredíte sa na to, čo vám zarába.',
      en: 'Wages, contracts, taxes, safety - we handle everything for you. Focus on what makes you money.',
      de: 'Löhne, Verträge, Abgaben, Arbeitsschutz - wir erledigen alles für Sie. Konzentrieren Sie sich auf das, was Ihnen Geld bringt.'
    },
    card3Title: { sk: 'Flexibilita bez záväzkov', en: 'Flexibility Without Commitment', de: 'Flexibilität ohne Verpflichtung' },
    card3Desc: { 
      sk: '5 ľudí na týždeň alebo 50 na rok. Škálujte tím podľa aktuálnych potrieb a sezónnych výkyvov.',
      en: '5 people for a week or 50 for a year. Scale your team according to current needs and seasonal fluctuations.',
      de: '5 Leute für eine Woche oder 50 für ein Jahr. Skalieren Sie Ihr Team nach aktuellen Bedürfnissen und saisonalen Schwankungen.'
    },
  },

  // ===== POSITIONS SECTION =====
  positionsSection: {
    title: { sk: 'Aké pozície obsadzujeme?', en: 'What positions do we fill?', de: 'Welche Positionen besetzen wir?' },
    subtitle: { sk: 'Od výroby cez logistiku až po stavebníctvo', en: 'From manufacturing to logistics to construction', de: 'Von der Produktion über Logistik bis zum Bauwesen' },
    cta: { sk: 'Potrebujem iné pozície', en: 'I need other positions', de: 'Ich brauche andere Positionen' },
    list: {
      sk: ['Muráři', 'Montážnici', 'Zvárači', 'Skladníci', 'Operátori CNC', 'Vodiči VZV', 'Elektrikári', 'Maliari', 'Zámočníci', 'Tesári', 'Strojári', 'Brúsiči', 'Obrábaři', 'Robotníci', 'Pomocní pracovníci'],
      en: ['Bricklayers', 'Assemblers', 'Welders', 'Warehouse Workers', 'CNC Operators', 'Forklift Drivers', 'Electricians', 'Painters', 'Locksmiths', 'Carpenters', 'Machinists', 'Grinders', 'Machine Operators', 'Laborers', 'General Workers'],
      de: ['Maurer', 'Monteure', 'Schweißer', 'Lagerarbeiter', 'CNC-Bediener', 'Gabelstaplerfahrer', 'Elektriker', 'Maler', 'Schlosser', 'Zimmerer', 'Maschinisten', 'Schleifer', 'Maschinenbediener', 'Arbeiter', 'Hilfsarbeiter']
    }
  },

  // ===== HOW IT WORKS =====
  howItWorks: {
    title: { sk: 'Ako to funguje?', en: 'How does it work?', de: 'Wie funktioniert es?' },
    step1Title: { sk: 'Kontaktujte nás', en: 'Contact Us', de: 'Kontaktieren Sie uns' },
    step1Desc: { sk: 'Povedzte nám, koľko ľudí a na aké pozície potrebujete.', en: 'Tell us how many people and what positions you need.', de: 'Sagen Sie uns, wie viele Leute und welche Positionen Sie benötigen.' },
    step2Title: { sk: 'Vyberieme kandidátov', en: 'We Select Candidates', de: 'Wir wählen Kandidaten aus' },
    step2Desc: { sk: 'Z našej databázy vyberieme najvhodnejších pracovníkov.', en: 'We select the most suitable workers from our database.', de: 'Wir wählen die geeignetsten Arbeitskräfte aus unserer Datenbank aus.' },
    step3Title: { sk: 'Pracujú u vás', en: 'They Work For You', de: 'Sie arbeiten für Sie' },
    step3Desc: { sk: 'Do 48 hodín sú pracovníci pripravení nastúpiť.', en: 'Within 48 hours, workers are ready to start.', de: 'Innerhalb von 48 Stunden sind die Arbeitskräfte bereit zu beginnen.' },
  },

  // ===== TESTIMONIALS =====
  testimonials: {
    title: { sk: 'Čo hovoria naši klienti', en: 'What our clients say', de: 'Was unsere Kunden sagen' },
    quote1: { 
      sk: 'Spolupráca s WorkPro nám ušetrila stovky hodín práce. Pracovníci sú spoľahliví a komunikácia je perfektná.',
      en: 'Working with WorkPro saved us hundreds of hours. Workers are reliable and communication is perfect.',
      de: 'Die Zusammenarbeit mit WorkPro hat uns Hunderte von Stunden gespart. Die Arbeiter sind zuverlässig und die Kommunikation ist perfekt.'
    },
    quote2: { 
      sk: 'Za 3 roky spolupráce sme obsadili viac ako 200 pozícií. Vždy načas a v požadovanej kvalite.',
      en: 'In 3 years of cooperation, we filled more than 200 positions. Always on time and with required quality.',
      de: 'In 3 Jahren Zusammenarbeit haben wir mehr als 200 Positionen besetzt. Immer pünktlich und in der erforderlichen Qualität.'
    },
  },

  // ===== PARTNERS =====
  partners: {
    title: { sk: 'Spolupracujeme s lídrami', en: 'We work with leaders', de: 'Wir arbeiten mit Marktführern' },
    subtitle: { 
      sk: 'Viac ako 100 spokojných klientov z rôznych odvetví nám dôveruje už vyše 4 roky.',
      en: 'More than 100 satisfied clients from various industries have trusted us for over 4 years.',
      de: 'Mehr als 100 zufriedene Kunden aus verschiedenen Branchen vertrauen uns seit über 4 Jahren.'
    },
  },

  // ===== CTA =====
  cta: {
    title1: { sk: 'Pripravení na', en: 'Ready for', de: 'Bereit für' },
    title2: { sk: 'spoluprácu?', en: 'cooperation?', de: 'Zusammenarbeit?' },
    description: { 
      sk: 'Kontaktujte nás a zistite, ako vám môžeme pomôcť s personálnym obsadením.',
      en: 'Contact us and find out how we can help you with staffing.',
      de: 'Kontaktieren Sie uns und erfahren Sie, wie wir Ihnen bei der Personalbesetzung helfen können.'
    },
    button: { sk: 'Kontaktujte nás', en: 'Contact Us', de: 'Kontaktieren Sie uns' },
  },

  // ===== FOOTER =====
  footer: {
    description: { 
      sk: 'Moderná agentúra dočasného zamestnávania. Spájame talenty s príležitosťami už viac ako 4 roky.',
      en: 'Modern temporary employment agency. Connecting talents with opportunities for over 4 years.',
      de: 'Moderne Zeitarbeitsagentur. Wir verbinden Talente mit Möglichkeiten seit über 4 Jahren.'
    },
    services: { sk: 'Služby', en: 'Services', de: 'Dienstleistungen' },
    forCompanies: { sk: 'Pre firmy', en: 'For Companies', de: 'Für Unternehmen' },
    company: { sk: 'Spoločnosť', en: 'Company', de: 'Unternehmen' },
    aboutUs: { sk: 'O nás', en: 'About Us', de: 'Über uns' },
    careers: { sk: 'Kariéra u nás', en: 'Careers', de: 'Karriere' },
    blog: { sk: 'Blog', en: 'Blog', de: 'Blog' },
    contact: { sk: 'Kontakt', en: 'Contact', de: 'Kontakt' },
    openPositions: { sk: 'Voľné pozície', en: 'Open Positions', de: 'Offene Stellen' },
    privacy: { sk: 'Ochrana osobných údajov', en: 'Privacy Policy', de: 'Datenschutz' },
    terms: { sk: 'Obchodné podmienky', en: 'Terms of Use', de: 'Nutzungsbedingungen' },
    cookies: { sk: 'Cookies', en: 'Cookies', de: 'Cookies' },
    copyright: { sk: '© 2025 ALS HR s.r.o. Všetky práva vyhradené.', en: '© 2025 ALS HR s.r.o. All rights reserved.', de: '© 2025 ALS HR s.r.o. Alle Rechte vorbehalten.' },
  },

  // ===== COOKIE CONSENT =====
  cookie: {
    message: { 
      sk: 'Táto stránka používa cookies na zlepšenie vášho zážitku.',
      en: 'This site uses cookies to improve your experience.',
      de: 'Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern.'
    },
    accept: { sk: 'Súhlasím', en: 'Accept', de: 'Akzeptieren' },
    decline: { sk: 'Odmietnuť', en: 'Decline', de: 'Ablehnen' },
  },
};

// Helper function to get translation
export const t = (key, language) => {
  const keys = key.split('.');
  let value = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  return value?.[language] || value?.sk || key;
};
